import machine_app_implementation_loader from "../models/machine_app_implementation_loader";
import machine_app_state from "../models/machine_app_state";
import './machine_app_pendant_landing_page_views.css';

/**
 * @callback onEditCallback
 * @param {string} MachineAppType Unique type of this MachineApp (i.e. Palletizer, PathFollowing, etc.).
 */
/**
 * Returns the container for the pendant machine app landing page
 * @param {onEditCallback} onEdit
 */
export const getPendantLandingPage = (onEdit) => {
  const lContainer = $('<div>')
    .addClass('machineapp_available_page');
  const lTitle = $('<header>')
    .append($('<h1>').text('Available MachineApps'));
  const lList = $('<ul>');

  machine_app_state.getImplementationManager().listMachineAppDefinitions().forEach(function(pDefinition) {
    if (!pDefinition.getIsAvailable()) {
      return;
    }
    const lMachineAppType = pDefinition.getType();
    const lOptionalUiHooks = machine_app_implementation_loader.instance.getOptionalUiHooks(lMachineAppType);
    const lThumbnail = $('<div>')
      .addClass('machineapp_available_item_thumbnail')
      .append(lOptionalUiHooks.getThumbnail && lOptionalUiHooks.getThumbnail());

    const lFlavorText = machine_app_implementation_loader.instance.getFlavorText(lMachineAppType);
    const machineAppLibrary = machine_app_state.getLibraryManager().getLibraryByType(lMachineAppType);
    const lHasStartedSetup = machineAppLibrary.listMachineParameters().length !== 0;

    const lDescription = $('<div>')
      .addClass('machineapp_available_item_description')
      .append(
        $('<label>').text(lFlavorText.general.title),
        $('<p>').html(lFlavorText.general.description)
      );
    const lEditButton = $('<button>')
      .text('Start')
      .on('click', () => onEdit(lMachineAppType))
      .addClass('machineapp_available_item_button')
      .addClass('machineapp_available_item_button_start');

    if(lHasStartedSetup) {
      lEditButton
        .removeClass('machineapp_available_item_button_start')
        .addClass('machineapp_available_item_button_continue')
        .text('Continue Setup');
    }

    lList.append(
      $('<li>').append(
        lThumbnail,
        lDescription,
        lEditButton
      )
    );
  });

  return lContainer.append(lTitle, lList);
};
